import { ProjectPermission } from '../types'
import { Permissions } from './permissions'

/**
 * Represents a supplier feature that can be activated or deactivated
 * in the supplier cockpit settings.
 */
export type SupplierFeature = 'orderProcess' | 'deliveryForecast' | 'eInvoice'

/**
 * Maps each supplier feature to the project permissions it controls.
 * Used to determine which menu items, routes, and roles should be
 * visible/accessible based on the supplier's active features.
 */
export const FEATURE_PERMISSION_MAP: Record<
  SupplierFeature,
  ProjectPermission[]
> = {
  orderProcess: [Permissions.Project.Worklist, Permissions.Project.History],
  deliveryForecast: [
    Permissions.Project.DeliveryForecastWorklist,
    Permissions.Project.DeliveryForecastHistory,
  ],
  eInvoice: [Permissions.Project.EInvoice, Permissions.Project.EInvoiceHistory],
}

/**
 * Reverse mapping: from a permission name to the feature it belongs to.
 * Returns undefined for permissions not tied to a specific feature
 * (e.g. ProjectUserAdmin, ProjectSettings, Trial).
 */
export function getFeatureForPermission(
  permissionName: string,
): SupplierFeature | undefined {
  const lowerName = permissionName.toLowerCase()
  for (const [feature, permissions] of Object.entries(FEATURE_PERMISSION_MAP)) {
    if (permissions.some(p => p.toLowerCase() === lowerName)) {
      return feature as SupplierFeature
    }
  }
  return undefined
}
